module.exports = __webpack_public_path__ + "img/image-3.acda2463.jpg";